import { useField, useFormikContext } from 'formik'
import get from 'lodash.get'
import { IVenueFormValues } from 'FormPage/FormPage'
import {
  Input as UIInput,
  ITextareaProps,
} from '@nextretreat/ui-components/dist/Input'

interface IInputFormikProps extends Omit<ITextareaProps, 'name'> {
  name: string
}

export const TextareaFormik = ({
  invalid,
  name,
  placeholder,
  ...passingProps
}: IInputFormikProps) => {
  const { errors, touched } = useFormikContext<IVenueFormValues>()
  const [field] = useField({ name: name, type: 'textarea', placeholder })

  return (
    <UIInput.Textarea
      {...passingProps}
      {...field}
      placeholder={placeholder}
      invalid={invalid || !!(get(errors, name) && get(touched, name))}
    />
  )
}
